export const DAO_CODE = 'GLOBALS' + '_DAO';
